var language_and_ship_to_switcher_version = "_v4";

jQuery(document).ready(function ($) {
  $("#country_language_switcher").submit(function (e) {
    e.preventDefault();
    $(this).find(".loader").removeClass("hidden");
    var new_lang = $('#country_language_switcher input[name="new_lang"]').val();
    var new_lang_link = $('link[rel="alternate"][hreflang="' + new_lang + '"]')
      .first()
      .attr("href");

    $.ajax({
      type: "POST",
      dataType: "json",
      url: bar_ajax_url,
      data: {
        action: "bar_change_language_and_ship_to_country",
        form: $("#country_language_switcher").serialize(),
        current_page: location.href,
        new_lang_link: new_lang_link,
      },
      success: function (data) {
        if (data.redirect_to) {
          if (data.selected_country_code) {
            setLocalStorage("bar_country_code", data.selected_country_code, "no_expire");
          }
          if (data.selected_country_is_eu) {
            setLocalStorage("bar_country_is_eu", data.selected_country_is_eu, "no_expire");
          }
          if (data.currency_switched) {
            $(document.body).trigger("wc_fragment_refresh");
            $(document.body).on("wc_fragments_refreshed", function (e) {
              document.location = data.redirect_to;
            });
          } else {
            document.location = data.redirect_to;
          }
        } else {
          $("#country_language_switcher").addClass("hidden").find(".loader").addClass("hidden");
          $(".mfp-wrap.off-canvas").attr("tabindex", -1);
        }
      },
      error: function (data) {
        console.log("Error: There was a problem updating language / shipping to country. Going to reload the page.");
        document.location.reload();
      },
    });
  });

  $("#country_language_switcher").on("click", function (e) {
    if (e.target.id === "country_language_switcher") {
      $(this).addClass("hidden");
      $(".mfp-wrap.off-canvas").attr("tabindex", -1);
    }
  });

  $("#country_language_switcher").on("click", "a.wpml-ls-link", function (e) {
    e.preventDefault();
    $(this).closest("#country_language_switcher").find(".wpml-ls-item").removeClass("wpml-ls-current-language");
    var current_item = $(this).closest(".wpml-ls-item");
    current_item.addClass("wpml-ls-current-language");
    var selected_lang = current_item.find(".wpml-ls-native").attr("lang");
    $("#country_language_switcher").find("input[name='new_lang']").val(selected_lang);
  });

  $("#country_language_switcher").on("click", ".wcml_currency_switcher li", function (e) {
    e.preventDefault();
    $(this).closest(".wcml_currency_switcher").find("li").removeClass("wcml-cs-active-currency");
    $(this).addClass("wcml-cs-active-currency");
    var new_currency = $(this).find("a").attr("rel");
    $(".new_currency").val(new_currency);
  });

  $("body").on("click", ".open_country_language_switcher", function (e) {
    $("#country_language_switcher").removeClass("hidden");
    // remove the tabindex to avoid a bug in iOS safari
    $(".mfp-wrap.off-canvas").removeAttr("tabindex");
  });

  getAndSetLocalicationFeatures();
});

function getAndSetLocalicationFeatures() {
  var selected_country = getLocalStorage("bar_country_code");
  if (!selected_country || selected_country.toLowerCase() === "undefined") {
    selected_country = getCookie("bar_country_code"); //used for initial GEO-Redirection!
    setLocalStorage("bar_country_code", selected_country, "no_expire"); //used from now on
  }
  if (!selected_country) {
    selected_country = "";
  }
  var lang = getCookie("wp-wpml_current_language");
  var banner_text = getLocalStorage(
    "bar_banner_text_" + selected_country.toLowerCase() + "_" + lang + language_and_ship_to_switcher_version
  );
  banner_text = decodeURI(banner_text);
  banner_text = banner_text.replace("#SEMICOLON#", ";");
  if (banner_text && banner_text !== "undefined" && selected_country) {
    setBannerText(banner_text, 100);
    setSelectedCountry(selected_country);
  } else {
    if (typeof wpml_cookies !== "undefined") {
      //copied from sitepress-multilingual-cms/res/js/cookies/language-cookie.js to set this cookie before getting location features...
      jQuery.each(wpml_cookies, function (cookieName, cookieData) {
        document.cookie =
          cookieName + "=" + cookieData.value + ";expires=" + cookieData.expires + "; path=" + cookieData.path;
      });
    }

    $.ajax({
      type: "POST",
      dataType: "json",
      url: bar_ajax_url,
      data: {
        action: "bar_get_localization_features",
        selected_country: selected_country,
      },
      success: function (data) {
        if (data.banner_text) {
          var text = data.banner_text;
          text = text.replace(";", "#SEMICOLON#");
          var text = encodeURI(text);
          var lang = getCookie("wp-wpml_current_language");
          setLocalStorage(
            "bar_banner_text_" +
              data.selected_country_code.toLowerCase() +
              "_" +
              lang +
              language_and_ship_to_switcher_version,
            text,
            1
          );
          setBannerText(data.banner_text);
        }
        if (data.selected_country_code) {
          setLocalStorage("bar_country_code", data.selected_country_code.toUpperCase(), "no_expire");
          setSelectedCountry(data.selected_country_code);
        }
        if (data.selected_country_is_eu) {
          setLocalStorage("bar_country_is_eu", data.selected_country_is_eu, "no_expire");
        }
      },
      error: function (data) {},
    });
  }
}

function setBannerText(text, duration = 400) {
  $(".header_banner .inner").html(text).fadeIn(duration);
}

function setSelectedCountry(selected_country_code) {
  $("#delivery_country").val(selected_country_code.toUpperCase());
}

function getCookie(cName) {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split("; ");
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });
  return res;
}

function getLocalStorage(cName) {
  var expire_saved_val = window.localStorage.getItem(cName + "-expiring");
  if (expire_saved_val === "no_expire") {
    return window.localStorage.getItem(cName);
  }

  var expiring_time_in_minutes = parseInt(expire_saved_val);
  if (!expiring_time_in_minutes) {
    return "";
  }
  var now_minutes = parseInt(Date.now() / 1000 / 60);
  if (expiring_time_in_minutes > now_minutes) {
    return window.localStorage.getItem(cName);
  }

  return "";
}

function setLocalStorage(cname, cvalue, days_to_expire) {
  window.localStorage.removeItem(cname);
  window.localStorage.setItem(cname, cvalue);
  var now_minutes = parseInt(Date.now() / 1000 / 60);
  if (days_to_expire === "no_expire") {
    window.localStorage.setItem(cname + "-expiring", "no_expire");
  } else {
    window.localStorage.setItem(cname + "-expiring", now_minutes + 24 * 60 * days_to_expire);
  }
}

module.exports = { setLocalStorage, getLocalStorage };
